import { useEffect } from 'react';
import AuthenticatedRoutes from './configs/routes/authenticatedRoutes';
import "./components/common/commonStyles.scss";
import { MsalProvider } from '@azure/msal-react';
import msalInstance from './configs/auth/msalInstance';
import Loading from './components/common/loader';

const App = ({ }) => {

  useEffect(() => {
    // Handle redirect after the user is returned from the flow
    msalInstance.handleRedirectPromise()
      .then((response) => {
        if (response) {
          // Handle successful authentication here
          console.log("User signed in:", response.account);
        }
      })
      .catch((error) => {
        // If the error is caused by user cancellation (AADB2C90091)
        if (error.errorCode === "AADB2C90091") {
          console.log("User cancelled the password reset flow.");
          // You can redirect the user to a safe page
          window.location.href = "/";  // Redirect to a safe page or handle as needed
        } else {
          console.error("Error during the password reset flow:", error);
        }
      });
  }, [msalInstance]);

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedRoutes />
      <Loading />
    </MsalProvider>
  );
}


export default App;